import React, { memo, forwardRef } from 'react'
import Markdown from '../../../components/Markdown'
import { Icon, CircleButton } from '../../../components'
import { ANSWERED } from '../../../config'
import styled from 'styled-components'

const ChildLabel = styled.label`
 background-color: ${props => props.theme.colorTable.backLight};
 color:${props => props.theme.colorTable.backLightText};
 flex-grow: 1;
 padding: 0.375rem 0.75rem;
`

function ChildLink ({ id, index, status, hasData, text, showModal, activate, isTurn, readOnly }, ref) {
  const inList = (typeof index === 'number' && index >= 0)
  return (
    <div className={inList ? 'mb-1 w-100' : ''} style={{ display: 'flex', alignItems: 'center' }}>
      <CircleButton id={id}
                    ref={ref}
                    icon={readOnly ? 'icon-eye-fill2' : 'icon-arrow-right'}
                    label={null}
                    onClick={showModal}
                    activate={activate}
                    isTurn={isTurn}
      />
      <ChildLabel htmlFor={id} className={'rounded m-0'}>
        <Icon type={mapIcon(status)}
              className={'align-middle ans-status-icon ' + mapIconStyle(status)}
              style={{ float: 'right' }}/>
        <p className={'p-0 m-0' + (hasData ? '' : ' font-italic')}>
          {inList ? (index + 1) + '.  ' : ''}
          {(hasData && text) ? (<Markdown>{text}</Markdown>) : `(click to ${readOnly ? 'view' : 'edit'})`}
        </p>
      </ChildLabel>
    </div>
  )
}

const mapIcon = status => {
  switch (status) {
    case ANSWERED.NONE:
      return 'icon-circle'
    case ANSWERED.PART:
      return 'icon-dot-circle'
    case ANSWERED.FULL:
      return 'icon-check-circle'
    default:
      return 'icon-warning'
  }
}

const mapIconStyle = status => {
  switch (status) {
    case ANSWERED.NONE:
      return 'ans-status-none'
    case ANSWERED.PART:
      return 'ans-status-part'
    case ANSWERED.FULL:
      return 'ans-status-full'
    default:
      return ''
  }
}

export default memo(forwardRef(ChildLink))
